import { apiClient } from '../httpClient';

export const financeService = {
  getAccountsReceivableList: async ({ startDate, endDate, company, customerId }) => {
    const params = { start_date: startDate };
    if (endDate) params.end_date = endDate;
    if (company) params.company = company;
    if (customerId) params.customer_id = customerId;
    const res = await apiClient.get('/finance/accounts-receivable/grouped-by-customer', { params });
    return res.data;
  },

  getAccountsReceivableByCustomer: async ({ customerId, startDate, endDate }) => {
    const params = { start_date: startDate };
    if (endDate) params.end_date = endDate;
    const res = await apiClient.get(`/finance/accounts-receivable/by-customer/${customerId}`, { params });
    return res.data;
  },

  createPaymentItem: async (payload) => {
    const res = await apiClient.post('/finance/payments/item', payload);
    return res.data;
  },

  getPaymentList: async ({ startDate, endDate, customerId }) => {
    const params = { start_date: startDate };
    if (endDate) params.end_date = endDate;
    if (customerId) params.customer_id = customerId;
    const res = await apiClient.get('/finance/payments/list', { params });
    return res.data;
  },

  deletePaymentItem: async (paymentId) => {
    const res = await apiClient.delete(`/finance/payments/item/${paymentId}`);
    return res.data;
  },

  getInvoiceList: async ({ startDate, endDate, customerId }) => {
    const params = { start_date: startDate };
    if (endDate) params.end_date = endDate;
    if (customerId) params.customer_id = customerId;
    const res = await apiClient.get('/invoice/v1/invoice/list', { params });
    return res.data;
  }
};

export default financeService;

